'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHublessUserInfo = undefined;

var _noPortalApiClient = require('../utils/http/noPortalApiClient');

var _noPortalApiClient2 = _interopRequireDefault(_noPortalApiClient);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getHublessUserInfo = exports.getHublessUserInfo = function getHublessUserInfo() {
  return _noPortalApiClient2.default.get('/login-verify/user-info', {
    ignoreRedirect: true
  });
};